import React, { memo } from 'react';
import PropTypes from 'prop-types';
import { CheckboxStyled, StyledInput, StyledLabel, StyledBox } from './styles/CheckboxStyled';

const Checkbox = ({ elementId, getRef, text }) => (
  <CheckboxStyled>
    <StyledInput type="checkbox" id={elementId} ref={getRef} />
    <StyledLabel htmlFor={elementId}>{text}</StyledLabel>
    <StyledBox />
  </CheckboxStyled>
);

Checkbox.propTypes = {
  elementId: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  getRef: PropTypes.func,
};

Checkbox.defaultProps = {
  getRef: Function.prototype,
};

export default memo(Checkbox);
